module.exports = __webpack_public_path__ + "static/img/bg-index.2b66c48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rongyao2025/bg-index.jpg
// module id = Y2vh
// module chunks = 1